<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.icon" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="icon" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.rounded" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="rounded" /><!--
          --><checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.dismissible" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="dismissible" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24" v-if="alerts.length">
        <alert
          @dismiss="log('dismiss', 'alert', $event)"
          v-for="(alert, index) in alerts"
          v-model="alert.model"
          v-if="index < 4"
          :class="['mb-4']"
          :rounded="rounded"
          :dismissible="dismissible"
          :icon="icon ? '' : 'some-icon'"
          :key="index"
          :type="alert.type">
          <lorem-ipsum />
        </alert>
      </flex-col>
      <flex-col :span="24">
        <h-three title="Custom Alerts" />
      </flex-col>
      <flex-col :span="24" v-if="alerts.length">
        <alert
          @dismiss="log('dismiss', 'alert', $event)"
          v-model="alerts[4].model"
          type="custom"
          bg-color="pink"
          color="white"
          icon="home"
          :rounded="false"
          :dismissible="false"
          :color-lightness="null"
          :bg-color-lightness="500">
          <lorem-ipsum />
        </alert>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageAlert',
  mixins: [
    methods
  ],
  data () {
    return {
      alerts: [],
      rounded: true,
      icon: true,
      dismissible: true
    }
  },
  mounted () {
    this.getExternalData('alert.json', 'alerts')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/alert.vue